import React, { SyntheticEvent } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button } from '../components';
import { FormInput } from '../components/forms/FormInput';
import { handleValidateEmail } from '../data/handleValidateEmail';

export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  const [email, setEmail] = React.useState('');
  const [working, setWorking] = React.useState(false);
  const navigate = useNavigate();
  const handleSubmitClick = async (e: SyntheticEvent) => {
    e.preventDefault();
    window.localStorage.setItem('initialEmail', email);
    setWorking(true);
    let endPoint = 'login';
    const validatedEndPoint = await handleValidateEmail({ email: email });
    if (validatedEndPoint?.data?.status === 'success') {
      setWorking(false);
      endPoint = validatedEndPoint.data.message;
    }
    setWorking(false);
    navigate({
      to: `/${endPoint}`,
      from: '/',
    });
  };

  return (
    <div className="flex h-screen flex-col items-center justify-center bg-stone-100">
      <img
        src="https://storage.googleapis.com/mideoid-console-public/logos/MIDEOhealth.png"
        alt="mideo_logo"
        className="h-36"
      />
      {/* <Button id="nav-login" type="button" textContent="Go to Login Page" onClick={handleSubmitClick} /> */}
      {/* <Button id="nav-enroll" type="button" textContent="Go to Employer Enrollment" onClick={handleEnrollClick} /> */}
      <form className="mt-4 flex flex-col items-center">
        <FormInput
          id="username"
          handleBlur={() => {}}
          label="Enter Email Address to Continue*"
          name="username"
          value={email}
          handleChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
        />
        <p className="w-1/2 text-center text-xl italic">
          *Patients redeeming a benefit from their workplace or organization should enter their company email address.
        </p>
        <Button
          id="submit"
          type="submit"
          onClick={(e) => handleSubmitClick(e)}
          textContent="Submit"
          working={working}
          disabled={working}
          workingText="Checking email..."
        />
      </form>
    </div>
  );
}
